export default "__VITE_ASSET__75AgtK8v__"